// 主入口文件 - 强化调用链
import './style.css';
import { setupI18n } from './i18n.js';
import { run } from './generator.js';
import { copySQL, exportJSON, exportMD, downloadSQL } from './export.js';
import { initEditors, initOutputEditors, getSql, setSql } from './editor.js';

const EXAMPLE_LOCAL = `CREATE TABLE users (
  id bigint PRIMARY KEY AUTO_INCREMENT,
  username varchar(255) NOT NULL COMMENT '用户名',
  email varchar(255) DEFAULT NULL,
  created_at datetime DEFAULT CURRENT_TIMESTAMP
);

CREATE TABLE posts (
  id bigint PRIMARY KEY,
  user_id bigint NOT NULL,
  title varchar(255) NOT NULL,
  CONSTRAINT fk_user FOREIGN KEY (user_id) REFERENCES users(id)
);`;

const EXAMPLE_PROD = `CREATE TABLE users (
  id bigint PRIMARY KEY,
  name varchar(255) NOT NULL,
  created_at datetime
);`;

const DEFAULT_STATE = {
  dialect: 'mysql',
  options: { allowAddCol: true, allowAddIndex: true, cmpComment: true, enableRisk: true, showAst: false, genRollback: true, denyDrop: true },
  localSql: "",
  prodSql: ""
};

function saveState() {
  const state = {
    dialect: document.getElementById('dialect').value,
    options: {
      allowAddCol: document.getElementById('allowAddCol').checked,
      allowAddIndex: document.getElementById('allowAddIndex').checked,
      cmpComment: document.getElementById('cmpComment').checked,
      enableRisk: document.getElementById('enableRisk').checked,
      showAst: document.getElementById('showAst').checked,
      genRollback: document.getElementById('genRollback').checked,
      denyDrop: document.getElementById('denyDrop').checked
    },
    localSql: getSql('local'),
    prodSql: getSql('prod')
  };
  localStorage.setItem('sql_diff_pro_state', JSON.stringify(state));
}

function loadState() {
  const saved = localStorage.getItem('sql_diff_pro_state');
  const state = saved ? JSON.parse(saved) : DEFAULT_STATE;
  document.getElementById('dialect').value = state.dialect;
  Object.keys(state.options).forEach(opt => {
    const el = document.getElementById(opt);
    if (el) el.checked = state.options[opt];
  });
  setSql('local', state.localSql);
  setSql('prod', state.prodSql);
}

function showError(msg) {
  const el = document.getElementById('errorBanner');
  if (msg) {
    el.innerText = msg;
    el.classList.remove('hidden');
    setTimeout(() => showError(null), 5000);
  } else el.classList.add('hidden');
}

// 全局暴露
window.app = {
  run: () => {
    console.log('App: Run');
    saveState();
    showError(null);
    try {
      run();
    } catch (e) {
      showError("Analysis failed: " + e.message);
    }
  },
  loadExample: () => {
    console.log('App: Load Example');
    setSql('local', EXAMPLE_LOCAL);
    setSql('prod', EXAMPLE_PROD);
    window.app.run();
  },
  copySQL: (type) => {
    console.log('App: Copy SQL', type);
    copySQL(type);
  },
  downloadSQL: (type, filename) => {
    console.log('App: Download SQL', type, filename);
    downloadSQL(type, filename);
  },
  exportJSON: () => {
    console.log('App: Export JSON');
    exportJSON();
  },
  exportMD: () => {
    console.log('App: Export MD');
    exportMD();
  }
};

document.addEventListener('DOMContentLoaded', () => {
  try {
    setupI18n();
    const yearEl = document.getElementById('currentYear');
    if (yearEl) yearEl.innerText = new Date().getFullYear();
    
    initEditors(document.getElementById('localSql'), document.getElementById('prodSql'), 'mysql', saveState);
    initOutputEditors(document.getElementById('sql'), document.getElementById('rollbackSql'));
    loadState();
    
    const autoSaveIds = ['dialect', 'allowAddCol', 'allowAddIndex', 'cmpComment', 'enableRisk', 'showAst', 'genRollback', 'denyDrop'];
    autoSaveIds.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.addEventListener('change', saveState);
    });

    if (window.matchMedia('(prefers-color-scheme: dark)').matches) document.documentElement.classList.add('dark');
  } catch (e) {
    console.error('Init failed', e);
  }
});
